var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { class: _vm.classes, on: { click: _vm.handleClick } }, [
    _vm._v(_vm._s(_vm.date))
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00ce1925", { render: render, staticRenderFns: staticRenderFns })
  }
}